import { Checkbox, ConfigProvider } from "antd";
import React from "react";
import { PRIMARY_COLOR } from "../utils";

const CheckboxAntd = ({ label = "", checked, onChange, disabled = false }) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: PRIMARY_COLOR,
        },
      }}
    >
      <Checkbox checked={checked} onChange={onChange} disabled={disabled}>
      {/* {label} */}
      {/* //added by Krishnaja */}<span style={{fontWeight:'bold'}}>{label}</span>
      </Checkbox>
    </ConfigProvider>
  );
};

export default CheckboxAntd;
